<template>
  <div class="body">
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="140px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试名称" prop="examName" class="item">
              <el-input disabled v-model="form.examName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试地点" prop="examLocation">
              <el-input disabled v-model="form.examLocation"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="合格分数" prop="passingScore">
              <el-input
                disabled
                type="number"
                v-model="form.passingScore"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="总分数" prop="fraction" class="item">
              <el-input
                disabled
                type="number"
                v-model="form.fraction"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item
              label="考试时长(分钟)"
              prop="examDuration"
              class="item"
            >
              <el-input
                disabled
                type="number"
                v-model="form.examDuration"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试次数" prop="examFrequency" class="item">
              <el-input
                disabled
                type="number"
                v-model="form.examFrequency"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考试时间" prop="date" class="item">
              <el-date-picker
                disabled
                v-model="form.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试类型" prop="examType">
              <el-select disabled v-model="form.examType" placeholder="请选择">
                <el-option
                  :label="item.text"
                  :value="item.code"
                  v-for="(item, index) in examTypeList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="是否需要签到" prop="isSignin" class="item">
              <el-switch
                disabled
                active-value="0"
                inactive-value="1"
                v-model="form.isSignin"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item
              label="是否随机排序"
              prop="upsetQuestions"
              class="item"
            >
              <el-switch
                disabled
                active-value="0"
                inactive-value="1"
                v-model="form.upsetQuestions"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <h2 class="body-title">试卷详情</h2>
        <el-table class="mb20" :data="paperList" style="width: 100%">
          <el-table-column
            prop="questionsPaperName"
            label="试卷名称"
          ></el-table-column>
          <el-table-column label="试卷类型">
            <template slot-scope="scope">{{
              scope.row.selectionMode == 0 ? "随机试题" : "固定试题"
            }}</template>
          </el-table-column>
          <!-- <el-table-column prop="date" label="所属部门"></el-table-column> -->
          <el-table-column
            prop="questionNumber"
            label="包含题目数量"
          ></el-table-column>
        </el-table>

        <h2 class="body-title">考试人员</h2>
        <el-table :data="personList" style="width: 100%" class="mb20">
          <el-table-column label="序号">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="label" label="对象名称"></el-table-column>
          <!-- <el-table-column label="操作" v-if="type != 'check'">
            <template slot-scope="scope">
              <el-button type="danger" @click="delPerson(scope.$index)">删除</el-button>
            </template>
          </el-table-column>-->
        </el-table>

        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import API from "../../api/new/training.js";
export default {
  data() {
    return {
      form: {
        examName: undefined,
        examLocation: undefined,
        passingScore: undefined,

        startTime: undefined,
        endTime: undefined,

        examType: "PXGL",
        fraction: undefined,
        examDuration: undefined,
        isSignin: undefined,
        upsetQuestions: undefined,
        examFrequency: 1,

        paperName: undefined,
        paperId: undefined,
        paperType: undefined,
        department: undefined,
        questionsNumber: undefined
      },
      paperList: [],
      personList: [],
      examTypeList:[],
    };
  },
  mounted() {
    this.relevanceExam();
        this.examTypeList = JSON.parse(localStorage.getItem("exam_type"));
  },
  methods: {
    relevanceExam(id) {
      API.relevanceExam({
        programTaskId: this.$route.query.id
      }).then(res => {
        this.form = res.data;
        this.form.examType = String(this.form.examType);
        this.form.isSignin = String(this.form.isSignin);
        this.form.upsetQuestions = String(this.form.upsetQuestions);
        this.form.date = [res.data.startTimeLong, res.data.endTimeLong];
        //   this.paperList = res.data.

        this.paperList = [
          {
            questionsPaperName: res.data.paperName,
            selectionMode: res.data.paperType,
            questionNumber: res.data.questionsNumber
          }
        ];
        this.personList = [];
        res.data.tasksJoinUsers &&
          res.data.tasksJoinUsers.forEach(v => {
            this.personList.push({
              label: v.busiName
            });
          });
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/examInfo.vue